import * as Helpers from '../Helpers/DatatableHelpers';
import * as DataFormat from '../../../../../Common/Scripts';

const MarkerMeetingsColumns = () => [
	{ dataField: 'rowId', text: 'Row Id', hidden: true, csvExport: false },
	{
		dataField: 'meetingId',
		text: 'Meeting ID',
		hidden: true
	},
	{
		dataField: 'qualificationYear',
		text: 'Year',
		headerClasses: 'th-td-xs',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'appointmentTypeCode',
		text: 'Type',
		headerClasses: 'th-td-xs',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'markingTeamId',
		text: 'Marking Team ID',
		hidden: true
	},
	{
		dataField: 'markingTeamTitle',
		text: 'Marking Team Title',
		sort: true,
		headerClasses: 'BigSizeColumn',
		classes: 'BigSizeColumn'
	},
	{
		dataField: 'markingTeamCode',
		text: 'Code',
		sort: true,
		headerClasses: 'th-td-sm',
		classes: 'tr-td-overflow-hide',
		csvFormatter: cell => DataFormat.writeDataWithLeadingZeroInCsv(cell)
	},
	{
		dataField: 'markingMethod',
		text: 'Marking Method',
		sort: true,
		headerClasses: 'MediumSizeColumn',
		classes: 'MediumSizeColumn'
	},
	{
		dataField: 'scriptDeliveryDate',
		text: 'Delivery Date',
		sort: true,
		headerClasses: 'MediumSizeColumn',
		classes: 'MediumSizeColumn',
		formatter: cell => Helpers.createTimeInput(cell),
		csvFormatter: cell => Helpers.createTimeInput(cell)
	},
	{
		dataField: 'scriptReturnDate',
		text: 'Return Date',
		sort: true,
		headerClasses: 'MediumSizeColumn',
		classes: 'MediumSizeColumn',
		formatter: cell => Helpers.createTimeInput(cell),
		csvFormatter: cell => Helpers.createTimeInput(cell)

	},
	{
		dataField: 'eMarkingStartDate',
		text: 'E Marking Start Date',
		sort: true,
		headerClasses: 'MediumSizeColumn',
		classes: 'MediumSizeColumn',
        formatter: cell => Helpers.createTimeInput(cell),
        csvFormatter: cell => Helpers.createTimeInput(cell)
	},
	{
		dataField: 'eMarkingEndDate',
		text: 'E Marking End Date',
		sort: true,
		headerClasses: 'MediumSizeColumn',
		classes: 'MediumSizeColumn',
		formatter: cell => Helpers.createTimeInput(cell),
		csvFormatter: cell => Helpers.createTimeInput(cell)

	},
	{
		dataField: 'markersMeeting',
		text: 'Marker Meeting Attendance',
		sort: true,
		headerClasses: 'MediumSizeColumn',
		classes: 'MediumSizeColumn'
	},
	{
		dataField: 'meetingDate',
		text: 'Marker Meeting Date',
		sort: true,
		headerClasses: 'MediumSizeColumn',
		classes: 'MediumSizeColumn',
		formatter: cell => Helpers.createTimeInput(cell),
		csvFormatter: cell => Helpers.createTimeInput(cell)
	},
	{
		dataField: 'venueName',
		text: 'Venue Name',
		sort: true,
		headerClasses: 'MediumSizeColumn',
		classes: 'MediumSizeColumn'
	},
	{
		dataField: 'address1',
		text: 'Venue Address 1',
		sort: true,
		headerClasses: 'MediumSizeColumn',
		classes: 'MediumSizeColumn'
	},
	{
		dataField: 'address2',
		text: 'Venue Address 2',
		sort: true,
		headerClasses: 'MediumSizeColumn',
		classes: 'MediumSizeColumn'
	},
	{
		dataField: 'address3',
		text: 'Venue Address 3',
		sort: true,
		headerClasses: 'MediumSizeColumn',
		classes: 'MediumSizeColumn'
	},
	{
		dataField: 'address4',
		text: 'Venue Address 4',
		sort: true,
		headerClasses: 'MediumSizeColumn',
		classes: 'MediumSizeColumn'
	},
	{
		dataField: 'postcode',
		text: 'Venue Postcode',
		sort: true,
		headerClasses: 'MediumSizeColumn',
		classes: 'MediumSizeColumn'
	},
	{
		dataField: 'meetingTime',
		text: 'Marker Meeting Start Time',
		sort: true,
		headerClasses: 'MediumSizeColumn',
		classes: 'MediumSizeColumn',
		csvFormatter: cell => DataFormat.writeDataWithLeadingZeroInCsv(cell)
	},
	{
		dataField: 'meetingDuration',
		text: 'Marker Meeting Duration',
		sort: true,
		headerClasses: 'MediumSizeColumn',
		classes: 'MediumSizeColumn'
	}
];

export default MarkerMeetingsColumns;
